<card-info-detail-v2
  class="content-detail"
  [showButton]="showButton"
  (viewMoreLessEvent)="onClickViewMoreLess($event)"
>
  <h2 title *ngIf="!isDisney" i18n="@@amenities_servicios_del_alojamiento">
    Servicios del alojamiento
  </h2>
  <h2 title *ngIf="isDisney" i18n="@@amenities_servicios_del_hotel">
    Servicios del hotel
  </h2>
  <div class="amenities" expanded-info>
    <ng-container *ngFor="let amenity of amenities; let i = index">
      <div class="amenity">
        <mb-icon [icon]="amenity.icon"></mb-icon>
        <span class="text">{{ amenity.description }}</span>
      </div>
    </ng-container>
  </div>
</card-info-detail-v2>
